export function CrtButton({ children, type = 'button', variant = 'primary', onClick, disabled, loading, fullWidth }) {
  return (
    <button
      type={type}
      className={`crt-btn crt-btn-${variant} ${fullWidth ? 'crt-btn-full' : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <span className="crt-btn-load block-load">||||||||</span> : children}
    </button>
  )
}
